var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.266 13.333a1.066 1.066 0 0 0 .754-1.82L7.496 7.986l3.392-3.513a1.068 1.068 0 0 0-1.535-1.483l-4.12 4.267a1.067 1.067 0 0 0 .013 1.496l4.267 4.267c.208.208.481.312.754.312",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLeft;